module.exports = __webpack_public_path__ + "img/building.25431dea.svg";